var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoXbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 857 857.1",
    viewBox: "0 0 857 857.1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E7A0D",
    d: "m190.9 72.8c2.2-2.1 4.5-4.1 7-5.9 67.2-43.6 144.7-66.9 230.7-66.9 80.4 0 155.8 22.3 220 60.9 4.7 2.7 17.5 11.5 24 19.4-62.1-68.4-244.5 78.5-244.5 78.5-63-48.7-121.1-81.8-164.2-93.7-36.2-9.9-61.1-1.6-73 7.7zm551.9 64.6c-1.8-2.1-3.9-4-5.8-6.2-15.6-17.2-34.9-21.3-52.3-20.3-15.9 5.1-89 31.4-179.1 116.5 0 0 101.4 98.6 163.6 199.5 62.1 100.8 99.2 180.1 76.4 290 71.8-78.9 111.6-181.7 111.4-288.4 0-112.3-43.2-214.7-114.2-291.1zm-154.8 332.5c-39.5-44.2-80.4-87.2-122.5-128.9-11.8-11.7-24.3-24-37.5-36.7 0 0-19.8 19.8-45.4 45.8v-.1c-32.9 33.3-75.6 76.6-99.3 102-42.2 45-163.1 186.3-169.8 265.6 0 0-26.9-62.8 32.1-207.8 38.5-94.9 155-237.1 203.6-283.5 0 0-44.5-48.8-100.2-82.6l-.4-.1s-.7-.5-1.5-1c-26.8-16-56.2-28.4-84.3-30.1-28.7 2.1-47 23.2-47 23.2-74.5 79.1-116 184-115.8 292.9 0 236.7 191.8 428.5 428.6 428.5 125.6 0 238.5-54.1 317-140.3 0-.1-9-56.6-66.6-137.7-13.7-18.9-63.1-78.1-91-109.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoXbox);
export default __webpack_public_path__ + "static/media/logo-xbox.44d555c63081077b8123d772895c5174.svg";
export { ForwardRef as ReactComponent };